/**
 * Spot/Landmark 관련 유틸리티 함수
 */

/**
 * 국가 코드 → 언어 코드 매핑 테이블
 * 앱에서 지원하는 33개 언어 기반
 */
const COUNTRY_TO_LANG = {
    // 동아시아 (5개)
    'CN': 'zh', 'TW': 'zh-TW', 'HK': 'zh-TW',
    'JP': 'ja', 'KR': 'ko',

    // 동남아시아 (6개)
    'VN': 'vi', 'TH': 'th', 'ID': 'id',
    'MY': 'ms', 'PH': 'fil', 'MM': 'my',

    // 남아시아 (4개)
    'IN': 'hi', 'BD': 'bn', 'PK': 'ur', 'NP': 'ne',

    // 중동/아프리카 (6개)
    'SA': 'ar', 'AE': 'ar', 'EG': 'ar', 'IQ': 'ar',
    'IR': 'fa', 'KE': 'sw', 'TZ': 'sw', 'ZA': 'af',

    // 유럽 (17개)
    'DE': 'de', 'AT': 'de', 'CH': 'de',     // 독일어권
    'FR': 'fr', 'BE': 'fr',                     // 프랑스어권
    'IT': 'it', 'ES': 'es', 'PT': 'pt', 'BR': 'pt',
    'RU': 'ru', 'PL': 'pl', 'NL': 'nl', 'TR': 'tr',
    'GR': 'el', 'RO': 'ro', 'UA': 'uk', 'FI': 'fi',

    // 아메리카/오세아니아 (영어권)
    'US': 'en', 'CA': 'en', 'GB': 'en', 'AU': 'en',
    'NZ': 'en', 'IE': 'en', 'SG': 'en'
};

/**
 * 다국어 필드 값 반환 (Generic)
 * @param {Object} spot - 스팟 객체
 * @param {String} field - 필드명 (예: 'title', 'content')
 * @param {String} userLangCode - 사용자 언어 코드
 */
export const getLocalizedText = (spot, field, userLangCode) => {
    if (!spot || !spot[field]) return '';

    const fieldEn = `${field}_en`; // 예: title_en, content_en

    // 영문 필드가 없으면 원본 반환
    if (!spot[fieldEn]) {
        return spot[field];
    }

    // 🎯 수정: country 코드로 언어 추론 (lang 필드 없을 시 폴백)
    const itemLang = spot.lang || COUNTRY_TO_LANG[spot.country] || 'en';
    const userLang = (userLangCode || 'en').split('-')[0].toLowerCase();

    // 언어가 일치하면 원본(현지어) 반환
    if (userLang === itemLang.split('-')[0]) {
        return spot[field];
    }

    // 불일치 시 영문 반환
    return spot[fieldEn];
};

/**
 * 랜드마크 제목 반환 (Wrapper)
 */
export const getLocalizedTitle = (spot, userLangCode) => {
    return getLocalizedText(spot, 'title', userLangCode);
};

/**
 * 랜드마크 설명 반환 (Wrapper)
 */
export const getLocalizedContent = (spot, userLangCode) => {
    return getLocalizedText(spot, 'content', userLangCode);
};
